import { userConstants } from "../../constant";
let userExist = localStorage.getItem("user");
let user =
  userExist !== "undefined" && JSON.parse(localStorage.getItem("user"));
const initialState = user
  ? { loggedIn: true, user }
  : { loggedIn: false, user: null };

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.REQUEST_SUCCESS:
      return {
        loggingIn: !!userExist,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user,
        requires2fa: false,
        tempToken: null,
      };
    case userConstants.TFA_REQUIRED:
      return {
        loggedIn: false,
        user: null,
        requires2fa: true,
        tempToken: action.temp_token,
      };
    case userConstants.TFA_VERIFY_SUCCESS:
      return {
        ...state,
        requires2fa: false,
        tempToken: null,
      };
    case userConstants.REGISTER_SUCCESS:
      return {
        loggedIn: false,
        user: { isVerified: false },
      };
    case userConstants.VERIFY:
      return {
        loggedIn: false,
        user: { isVerified: true },
      };
    case userConstants.REQUEST_FAILURE:
      return {
        loggedIn: false,
        user: null,
        error:action?.error,
        requires2fa: false,
        tempToken: null,
      };
    case userConstants.LOGOUT:
      return { loggedIn: false, requires2fa: false, tempToken: null };
    default:
      return state;
  }
}
